import template from './flexAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      this.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              const self = this;
              self.email = '';
              self.username = '';
              self.password = '';
              self.confirm = () => {
                $mdDialog.hide({
                  email: self.email,
                  username: self.username,
                  password: self.password
                });
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
